/**
 * 设置cookie
 * @param {*} key
 * @param {*} value
 * @param {*} timer 分钟
 */
export const setCookie = function (key, value, timer) {
  let time = new Date();
  time.setTime(time.getTime() + timer * 60 * 1000);
  let expires = 'expires=' + time.toGMTString() + ';path=/';
  document.cookie = key + '=' + value + '; ' + expires;
};

/**
 * 获取cookie
 * @param {*} key
 * @returns
 */
export const getCookie = function (key) {
  key = key + '=';
  let cookie = document.cookie;
  let cookies = cookie.split(';');
  for (let item in cookies) {
    let value = cookies[item].trim();
    if (value.indexOf(key) === 0) {
      return value.slice(key.length, value.length);
    }
  }
  return null;
};

export const setLocalStorageExpire = function (key, value, timer) {
  let time = timer * 60 * 1000;
  localStorage.setItem(
    key,
    JSON.stringify({
      value,
      timer: new Date().getTime() + time,
    }),
  );
};

export const getLocalStorageExpire = function (key) {
  let data = localStorage.getItem(key);
  if (data) {
    try {
      // 判断是否过期
      let values = JSON.parse(data);
      if (!values.timer) {
        throw new Error('timer is null');
      }
      let { value, timer } = values;

      if (new Date().getTime() > timer) {
        localStorage.removeItem(key);
        return null;
      }
      return value;
    } catch (e) {
      // 格式不对，没有含过期时间
      return null;
    }
  }
  return null;
};
